const configurations  = require(`./environments/${process.env.REACT_APP_ENV}.json`);
export default configurations;
